import { fetchWithToken } from "@platform/core";
import { OktaUser } from "../../models/OktaUser";
import { WORK_ITEMS_BFF_API_BASE, WORKITEM_BFF_API_BASE_USERS } from "../../platform-workitems";
import { Dispatch, SetStateAction } from "react";
import { reportError } from "../../utils/errors";
import { Metrics } from "../../models/Metrics";

export async function getUsers(searchTerm: string): Promise<Response> {
  const baseUrl = WORKITEM_BFF_API_BASE_USERS;
  const searchQuery = `searchString=${searchTerm}`;
  const finalURL = `${baseUrl}?${searchQuery}`;

  return await fetchWithToken(`${finalURL}`, {
    method: "GET",
  });
}

export async function fetchUsers(
  searchTerm: string,
  setLoading: Dispatch<SetStateAction<boolean>>,
  setOktaUsers: Dispatch<SetStateAction<{ key: string; name: string; sentence: string }[]>>,
  setFetchUsersError: Dispatch<SetStateAction<string | null>>
) {
  setLoading(true);

  getUsers(searchTerm)
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(
          JSON.stringify({
            statusCode: response.status,
            statusText: response.statusText,
            body: await response.json(),
          })
        );
      }
      return response.json();
    })
    .then((response: OktaUser[]) => {
      if (response.length > 0) {
        let transformedResults = transformForSearch(response);
        setOktaUsers(transformedResults);
      } else if (!response || response.length == 0) {
        setOktaUsers([]);
      }
    })
    .catch((error) => {
      setFetchUsersError("Unable to fetch users. Please try again.");
      reportError(error.message);
    })
    .finally(() => setLoading(false));
}

export async function getMetrics(
  workItemTabType: string,
  filterCriteria: string
): Promise<Metrics | void> {
  return await fetchWithToken(
    `${WORK_ITEMS_BFF_API_BASE}/metrics?workItemTabType=${workItemTabType}&${filterCriteria}`
  )
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(JSON.stringify(response));
      }
      const contentType = response.headers.get("content-type");
      if (!contentType?.includes("application/json")) {
        throw new TypeError("Received non-JSON response");
      }
      return response.json();
    })
    .catch((error) => {
      reportError(error.message);
    });
}

export function transformForSearch(response: OktaUser[]) {
  return response.map((item) => ({
    key: item.ResourceIdentifier,
    name: item.FullName,
    sentence: `${item.FullName} - ${item.UserName}`,
  }));
}
